import React from "react";
import PropTypes from "prop-types";
import {useValue} from "@morningtrain/react-resources";
import {observer} from "mobx-react";
import {format} from "@morningtrain/helpers";

function Currency(props) {
    const {name, defaultValue, decimals} = props;

    let value = useValue(name, defaultValue);

    if (!(typeof value === 'number')) {
        value = parseFloat(value);
    }

    if (isNaN(value)) {
        return null;
    }

    if (decimals !== null) {
        value = parseFloat(value.toFixed(decimals));
    }

    const maxDecimals = (decimals !== null) ? decimals : props.maxDecimals;
    const minDecimals = (decimals !== null) ? decimals : props.minDecimals;

    return format.moneyFormat(value, maxDecimals, minDecimals, props.currency, props.locale);
}

Currency.defaultProps = {
    defaultValue: null,
    decimals: null,
    maxDecimals: 2,
    minDecimals: 2,
    currency: 'DKK',
    locale: 'da',
};

Currency.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    decimals: PropTypes.number,
    maxDecimals: PropTypes.number,
    minDecimals: PropTypes.number,
    currency: PropTypes.node,
    locale: PropTypes.string,
};

export default observer(Currency);
